export function getErrorObject (response) {
  if (response && response.response && response.response.data && response.response.data.error) { return response.response.data }
  if (response && response.data && response.data && response.data.error) { return response.data }
  if (response && response.error) { return response }
  return { error: 'INTERNAL_SERVER_ERROR' }
}

export function getErrorType (response) {
  return getErrorObject(response).error
}

export function transformError (result) {
  let error = getErrorObject(result)
  error.codes = []
  error.message = []

  if (error.details) {
    error.details.forEach(function (element) {
      if (element.indexOf(error.error) === 0 || element.indexOf('PAYMENT_PROVIDER_FAILURE') === 0) { error.codes.push(element) }
    }, this)
  }

  error.codes.push(error.error)
  return error
}

export function getErrorTranslation (translate, response) {
  let error = transformError(response)
  for (var i = 0; i < error.codes.length; i++) {
    let translation = translate('common:api:errors:' + error.codes[i])
    if (translation.indexOf('api.errors.') === -1) { return translation }
  }
  return 'api.errors.' + error.error
}



// WEBPACK FOOTER //
// ./src/utilities/errors.js